import { render } from "./page-not-found.vue?vue&type=template&id=4096c40e&ts=true"
import script from "./page-not-found.vue?vue&type=script&setup=true&lang=ts"
export * from "./page-not-found.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/page-not-found.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4096c40e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4096c40e', __exports__)) {
    api.reload('4096c40e', __exports__)
  }
  
  module.hot.accept("./page-not-found.vue?vue&type=template&id=4096c40e&ts=true", () => {
    api.rerender('4096c40e', render)
  })

}


export default __exports__